<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-messages *ngIf="useMessages" [(value)]="msg"></p-messages>

<!--<p-growl *ngIf="useGrowl" [key]="langErrorLabelPath"></p-growl>-->




